import axios from "axios";
import urlConfig from "../mixins/url";

class RawMaterialService {
    getAvaiableRawMaterials() {
        var url = urlConfig.data().url.serverUrl + urlConfig.data().url.RawMaterial.GetAvaiableRawMaterials;
        return axios
            .get(url);
    }

}

export default new RawMaterialService();
